import React from 'react';
import { View } from 'react-native';

import { ViewPropTypes, TextPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import FoundationTestKeys from '../../FoundationTestKeys';
import { useTheme, LightThemeColors } from '../Themes';
import VfText from '../VFText/VFText';

import styles from './Badge.styles';
import { BadgeTypesList } from './Badge.Utils';

function Badge({ type, text, textStyle, style, ...props }) {
  const theme = useTheme() || LightThemeColors;
  return (
    <View
      style={[styles.badgeStyle, type && styles[`${type}BadgeStyle`](theme), style]}
      testID={FoundationTestKeys.badgeView}
    >
      <VfText
        style={[styles.badgeTextStyle, textStyle]}
        i18nKey={text}
        {...props}
        testKey={FoundationTestKeys.badgeText}
      />
    </View>
  );
}

Badge.defaultProps = {
  textStyle: {},
  style: {},
  type: 'neutral',
};

Badge.propTypes = {
  type: PropTypes.oneOf(BadgeTypesList),
  text: PropTypes.string,
  textStyle: TextPropTypes.style,
  style: ViewPropTypes.style,
};

export default Badge;
